'use strict'

export default () => ({
  isValidContext: () => false
})
